import { render, staticRenderFns } from "./CollectionBlock.vue?vue&type=template&id=cd6f265a&scoped=true&"
import script from "./CollectionBlock.vue?vue&type=script&lang=js&"
export * from "./CollectionBlock.vue?vue&type=script&lang=js&"
import style0 from "./CollectionBlock.vue?vue&type=style&index=0&id=cd6f265a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6f265a",
  null
  
)

export default component.exports